import SkeletonBlock from '@loaders/SkeletonBlock';
import { memo } from 'react';

const ROW_COUNT = 4;
const DATA_COLUMN_COUNT = 5;

export const QuestsTableSkeleton = memo(() => (
  <div
    className="flex w-full flex-col overflow-hidden rounded-xl border border-merchant-border bg-white"
    aria-busy="true"
    aria-label="Loading quests"
  >
    <SkeletonBlock className="desktop:h-14 h-11 w-full rounded-none" />
    {Array.from({ length: ROW_COUNT }, (_, index) => (
      <div
        key={`quest-row-skeleton-${index}`}
        className="flex items-center border-t border-merchant-border desktop:px-6 px-4.5 desktop:py-4 py-3"
      >
        <div className="flex desktop:w-[520px] w-[390px] shrink-0 items-center desktop:gap-4 gap-3">
          <SkeletonBlock className="desktop:size-12 size-9 shrink-0 desktop:rounded-lg rounded-md" />
          <div className="flex flex-1 flex-col gap-1.5">
            <SkeletonBlock className="h-5 w-40 rounded" />
            <SkeletonBlock className="h-4 w-64 rounded" />
          </div>
        </div>
        {Array.from({ length: DATA_COLUMN_COUNT }, (__, column) => (
          <div key={column} className="flex flex-1 justify-center">
            <SkeletonBlock
              className={
                column >= DATA_COLUMN_COUNT - 2 ? 'h-9 w-20 rounded-full' : 'h-5 w-20 rounded'
              }
            />
          </div>
        ))}
      </div>
    ))}
    <div className="flex items-center justify-between border-t border-merchant-border desktop:p-5 p-4">
      <SkeletonBlock className="h-4 w-36 rounded" />
      <SkeletonBlock className="h-8 w-56 rounded" />
    </div>
  </div>
));

QuestsTableSkeleton.displayName = 'QuestsTableSkeleton';

const QuestsPageSkeleton = memo(() => (
  <div
    className="flex w-full flex-col desktop:gap-4 gap-3 animate-fade-in"
    aria-busy="true"
    aria-label="Loading quests"
  >
    <div className="flex flex-wrap items-center desktop:gap-3 gap-2">
      <SkeletonBlock className="h-8 w-28 flex-1 rounded" />
      <SkeletonBlock className="desktop:h-12 h-11 w-full max-w-[620px] flex-1 rounded-full" />
      <SkeletonBlock className="h-11 desktop:w-40 w-32 rounded-full" />
    </div>

    <div className="flex items-center gap-2">
      {['w-16', 'w-20', 'w-28', 'w-24'].map((width) => (
        <SkeletonBlock key={width} className={`h-9 ${width} rounded-full`} />
      ))}
    </div>

    <QuestsTableSkeleton />
  </div>
));

QuestsPageSkeleton.displayName = 'QuestsPageSkeleton';

export default QuestsPageSkeleton;
